export enum DynamicPropertyStatus {
    READY = 'ready',
    LOADING = 'loading',
}
